import * as yup from 'yup'

import { FieldInputProps } from '@/atoms/Field/includes/Input'

const priceForm: PriceForm[] = [
  {
    label: 'from',
    inputProps: {
      id: 'price_from',
      name: 'price_from',
      type: 'tel',
    },
  },
  {
    label: 'to',
    inputProps: {
      id: 'price_to',
      name: 'price_to',
      type: 'tel',
    },
  },
]

export const priceFormSchema = yup.object().shape({
  price_from: yup.number().positive(),
  price_to: yup.number().positive(),
})

interface PriceForm {
  label: string
  inputProps: {
    id: FieldInputProps['id']
    type: FieldInputProps['type']
    name: 'price_from' | 'price_to'
  }
}

export default priceForm
